import ApiService from './ApiService';
import { TAdminProfile } from '@/types/admin';

class AdminRepository extends ApiService {
  constructor() {
    super('');
  }

  async getAdminProfile(): Promise<TAdminProfile> {
    return await this.get<TAdminProfile>('/editor/users/current');
  }
}

export default new AdminRepository();
